import { render, staticRenderFns } from "./AddCourseWare.vue?vue&type=template&id=17bdbc50&scoped=true"
import script from "./AddCourseWare.vue?vue&type=script&lang=js"
export * from "./AddCourseWare.vue?vue&type=script&lang=js"
import style0 from "./AddCourseWare.vue?vue&type=style&index=0&id=17bdbc50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bdbc50",
  null
  
)

export default component.exports